// src/components/AuthButton.js
import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AccountCircle from "@mui/icons-material/AccountCircle";
import VpnKey from "@mui/icons-material/VpnKey";
import { useAuth } from "../auth/AuthProvider";
import LoginDialog from "./LoginDialog";

export default function AuthButton() {
  const { user, loading, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openLogin, setOpenLogin] = useState(false);

  if (loading) return null;

  if (!user) {
    return (
      <>
        <Tooltip title="Se connecter">
          <IconButton
            aria-label="Se connecter"
            onClick={() => setOpenLogin(true)}
            color="inherit"
            size="large"
          >
            <VpnKey />
          </IconButton>
        </Tooltip>
        <LoginDialog open={openLogin} onClose={() => setOpenLogin(false)} />
      </>
    );
  }

  return (
    <>
      <Tooltip title={`${user.email} • ${user.role}`}>
        <IconButton
          aria-label="Compte"
          color="inherit"
          size="large"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <AccountCircle />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem disabled>
          {user.email} • {user.role}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            logout();
          }}
        >
          Se déconnecter
        </MenuItem>
      </Menu>
    </>
  );
}
